import React from "react";

import { useResource } from "@rest-hooks/core";
import { Typography, TypographyProps } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import { VulcanDataResource, LoginResource } from "@ploy-lib/rest-resources";

export const SignedOnUser = (props: TypographyProps) => {
	const signedInAs = (
		<FormattedMessage
			id="form.user.signedInUser"
			description="Signed in as"
			defaultMessage="Innlogget som"
		/>
	);

	const { isAuthenticated } = useResource(LoginResource.status(), {});

	const vulcanData = useResource(
		VulcanDataResource.detail(),
		isAuthenticated ? {} : null
	);

	const { userFullName, credentialType } = vulcanData || {};
	const showSignedIn = credentialType === "External";

	return (
		<>
			{showSignedIn && (
				<Typography {...props}>
					{signedInAs}: {userFullName}
				</Typography>
			)}
		</>
	);
};
